module.exports = __webpack_public_path__ + "img/2.dec1c031.svg";